var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data && _vm.data.length)?_c('product-section',{attrs:{"title":"Akcesoria","padding-only-title":"","disable-mobile-background":"","disable-margin-bottom":"","h-tag":false}},[_c('LazyHydrate',{attrs:{"when-visible":""}},[_c('slider-tiles',{attrs:{"items":_vm.data,"slides-per-view":1,"breakpoints":{
        600: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },"loading":_vm.loading,"nav-buttons-type":"rounded"}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }